import React, { Component } from "react"
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from "prop-types"
import {
  CssBaseline, CircularProgress, Container, Button, Grid, Box, Paper,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Typography, Card, CardHeader, CardContent, Divider,
  Accordion, AccordionSummary, AccordionDetails, Chip, TextField
} from "@mui/material"
import { withStyles } from "@mui/styles"
import Pagination from '@mui/material/Pagination'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import moment from "moment"
import { injectIntl } from 'react-intl'
import { LineChart, Line, BarChart, Bar, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts'
import { Styles } from "../../styles/material-styles"
import { Overlay } from "../../styles/global"
import CustomizedSnackbars from "../../components/material-snackbars"
import HeaderMenu from "../../components/header-menu"
import Footer from '../../components/footer'
import SimpleDatePicker from '../../components/date-pickers/inline-no-today'
import SimpleAutoComplete from '../../components/auto-complete/autocomplete'
import SimpleAutoCompleteSearch from '../../components/auto-complete/autocomplete-search-api'
import Api from "../../services/api"
import ApiReports from "../../services/apireport"
import ScheduleReportButton from "../../components/report-schedule";
import LlmUsageDetailDrawer from './LlmUsageDetailDrawer'
import * as calledsActions from '../../redux/actions/calleds'

const ORIGIN_OPTIONS = [
  { id: 0, name: 'Todos' },
  { id: 'accompaniment', name: 'Chamado' },
  { id: 'chat', name: 'Chat' }
]

const SUCCESS_OPTIONS = [
  { id: 0, name: 'Todos' },
  { id: 1, name: 'Sucesso' },
  { id: 2, name: 'Falha' }
]

class LLMUsageReport extends Component {
  constructor(props) {
    super(props)

    this.isClient = true
    this.isAdm = false
    this.isAdmGlobal = false

    const { userSession } = this.props

    if (userSession == null || userSession.user == null || userSession.user.userrole == null)
      Api.logoff()

    userSession.user.userrole.map((item) => {
      if (item.role.roletype != 3)
        this.isClient = false
      if (item.role.roletype == 0 || item.role.roletype == 1)
        this.isAdm = true
      if (item.role.roletype == 0)
        this.isAdmGlobal = true
    })

    this.state = {
      dateStart: moment().subtract(1, 'months').format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      userFilter: 0,
      llmFilter: 0,
      originFilter: 0,
      successFilter: 0,
      relationedIdFilter: '',

      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
      showGrid: false,

      usageList: [],
      detailRow: null,
      detailData: null,
      detailLoading: false,

      llmList: [],

      summaryData: {},
      byDayData: [],
      byLLMData: [],
      byOutcomeData: {},

      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0
    }

    this.changeValues = this.changeValues.bind(this)
    this.clearFilters = this.clearFilters.bind(this)
  }

  async componentDidMount() {
    this.setState({ loading: true })
    await this.getLLMs()
    this.setState({ loading: false })
  }

  getLLMs = async () => {
    await Api.get('/llms')
      .then(result => {
        if (result.data.success)
          this.setState({ llmList: result.data.data })
      })
      .catch(() => {})
  }

  changeValues = async (stateName, value) => {
    if (value && value.id !== undefined) {
      this.setState({ [stateName]: value.id })
    } else {
      this.setState({ [stateName]: value })
    }
  }

  clearFilters = () => {
    this.setState({
      dateStart: moment().subtract(1, 'months').format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      userFilter: 0,
      llmFilter: 0,
      originFilter: 0,
      successFilter: 0,
      relationedIdFilter: '',
      showGrid: false,
      usageList: [],
      summaryData: {},
      byDayData: [],
      byLLMData: [],
      byOutcomeData: {},
      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0
    })
  }

  handleSubmit = async (e) => {
    e.preventDefault()
    this.setState({ loading: true })
    await this.fetchReport()
  }

  buildFilterParams = (dateStart, dateEnd) => {
    let params = `startDate=${dateStart}&endDate=${dateEnd}`

    if (this.state.userFilter && this.state.userFilter !== 0)
      params += `&userId=${this.state.userFilter}`

    if (this.state.llmFilter && this.state.llmFilter !== 0)
      params += `&llmId=${this.state.llmFilter}`

    if (this.state.originFilter && this.state.originFilter !== 0)
      params += `&origin=${this.state.originFilter}`

    const relationedId = parseInt(this.state.relationedIdFilter, 10)
    if (relationedId > 0)
      params += `&relationedId=${relationedId}`

    if (this.state.successFilter === 1)
      params += `&success=true`
    else if (this.state.successFilter === 2)
      params += `&success=false`

    return params
  }

  fetchReport = async () => {
    const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')

    if (moment(dateStart).isAfter(moment(dateEnd))) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: "A data inicial deve ser menor que a data final.",
        loading: false
      })
      return
    }

    await Promise.all([
      this.fetchPaginate(dateStart, dateEnd, 1),
      this.fetchSummary(dateStart, dateEnd),
      this.fetchByDay(dateStart, dateEnd),
      this.fetchByLLM(dateStart, dateEnd),
      this.fetchByOutcome(dateStart, dateEnd)
    ])

    this.setState({ showGrid: true, loading: false, scheduleRequest: `/report/llm-usage/paginate?${this.buildFilterParams(dateStart, dateEnd)}` }) // Agendamento de relatórios
  }

  fetchPaginate = async (dateStart, dateEnd, page) => {
    const params = this.buildFilterParams(dateStart, dateEnd)

    await ApiReports.get(`/report/llm-usage/paginate?${params}&page=${page}&pageSize=10`)
      .then(result => {
        if (result.data.success) {
          this.setState({
            usageList: result.data.data,
            count: result.data.count,
            page
          })
          this.setPagination(result.data.count, page)
        }
      })
      .catch(err => {
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors
            ? err.response.data.errors[0]
            : "Erro ao buscar relatório de uso de IA."
        })
      })
  }

  fetchSummary = async (dateStart, dateEnd) => {
    const params = this.buildFilterParams(dateStart, dateEnd)
    await ApiReports.get(`/report/llm-usage/summary?${params}`)
      .then(result => {
        if (result.data.success)
          this.setState({ summaryData: result.data.data })
      })
      .catch(() => {})
  }

  fetchByDay = async (dateStart, dateEnd) => {
    const params = this.buildFilterParams(dateStart, dateEnd)
    await ApiReports.get(`/report/llm-usage/by-day?${params}`)
      .then(result => {
        if (result.data.success)
          this.setState({ byDayData: result.data.data })
      })
      .catch(() => {})
  }

  fetchByLLM = async (dateStart, dateEnd) => {
    const params = this.buildFilterParams(dateStart, dateEnd)
    await ApiReports.get(`/report/llm-usage/by-llm?${params}`)
      .then(result => {
        if (result.data.success)
          this.setState({ byLLMData: result.data.data })
      })
      .catch(() => {})
  }

  fetchByOutcome = async (dateStart, dateEnd) => {
    const params = this.buildFilterParams(dateStart, dateEnd)
    await ApiReports.get(`/report/llm-usage/by-outcome?${params}`)
      .then(result => {
        if (result.data.success)
          this.setState({ byOutcomeData: result.data.data })
      })
      .catch(() => {})
  }

  onChangePaginate = (e, page) => {
    this.setState({ loading: true })
    const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')
    this.fetchPaginate(dateStart, dateEnd, page).then(() => {
      this.setState({ loading: false })
    })
  }

  setPagination = (count, page) => {
    const totalPage = Math.ceil(count / 10)
    this.setState({ totalPages: totalPage })
    if (count > 0) {
      if (page == 1) {
        this.setState({
          pageStart: 1,
          pageEnd: count < 10 ? count : 10
        })
      } else {
        const pageStart = ((page - 1) * 10) + 1
        this.setState({
          pageStart,
          pageEnd: count >= page * 10 ? page * 10 : count
        })
      }
    } else {
      this.setState({ totalPages: 0, page: 1, count: 0, pageStart: 0, pageEnd: 0 })
    }
  }

  openDetail = async (item) => {
    this.setState({ detailRow: item, detailData: null, detailLoading: true })

    try {
      const result = await ApiReports.get(`/report/llm-usage/${item.id}`)
      if (result.data && result.data.success) {
        if (this.state.detailRow && this.state.detailRow.id === item.id) {
          this.setState({ detailData: result.data.data })
        }
      } else {
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: (result.data && result.data.errors && result.data.errors[0]) || "Erro ao carregar o detalhe do registro."
        })
      }
    } catch (err) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: (err.response && err.response.data && err.response.data.errors && err.response.data.errors[0]) || "Erro ao carregar o detalhe do registro."
      })
    } finally {
      this.setState({ detailLoading: false })
    }
  }

  closeDetail = () => {
    this.setState({ detailRow: null, detailData: null })
  }

  closeNotification = () => {
    this.setState({ openNotification: false })
  }

  exportExcel = async () => {
    this.setState({ loading: true })
    try {
      const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
      const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')

      if (moment(dateStart).isAfter(moment(dateEnd))) {
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: "A data inicial deve ser menor que a data final.",
          loading: false
        })
        return
      }

      let successValue = null
      if (this.state.successFilter === 1) successValue = true
      else if (this.state.successFilter === 2) successValue = false

      const payload = {
        DateStart: dateStart,
        DateEnd: dateEnd,
        UserId: this.state.userFilter && this.state.userFilter !== 0 ? this.state.userFilter : null,
        LLMId: this.state.llmFilter && this.state.llmFilter !== 0 ? this.state.llmFilter : null,
        Origin: this.state.originFilter && this.state.originFilter !== 0 ? this.state.originFilter : null,
        Success: successValue,
        RelationedId: parseInt(this.state.relationedIdFilter, 10) > 0 ? parseInt(this.state.relationedIdFilter, 10) : null
      }

      const llmUsageExportEndpoint = '/report/llm-usage/excell/new'
      const response = await ApiReports.post(llmUsageExportEndpoint, payload)
      if (response.data && response.data.success) {
        this.setState({
          openNotification: true,
          notificationVariant: "success",
          notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")"
        })
      } else {
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: response && response.data && response.data.errors && response.data.errors[0]
            ? response.data.errors[0]
            : this.props.intl.formatMessage({ id: "process.error" })
        })
      }
    } catch (error) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: error && error.response && error.response.data && error.response.data.errors && error.response.data.errors[0]
          ? error.response.data.errors[0]
          : this.props.intl.formatMessage({ id: "process.error" })
      })
    }
    this.setState({ loading: false })
  }

  renderSummaryCards() {
    const { summaryData } = this.state
    const totalTokens = (summaryData.totaltokensinput || 0) + (summaryData.totaltokensoutput || 0)
    const estimatedCost = summaryData.totalestimatedcost != null ? Number(summaryData.totalestimatedcost).toFixed(4) : '0.0000'

    return (
      <Grid container spacing={2} style={{ marginBottom: 24 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography variant="caption" color="textSecondary">Total de Chamadas</Typography>
              <Typography variant="h5">{summaryData.totalcalls || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography variant="caption" color="textSecondary">Tokens Consumidos</Typography>
              <Typography variant="h5">{totalTokens}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography variant="caption" color="textSecondary">Usuários Ativos</Typography>
              <Typography variant="h5">{summaryData.activeusers || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography variant="caption" color="textSecondary">Custo Estimado</Typography>
              <Typography variant="h5">R$ {estimatedCost}</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    )
  }

  renderDailyCallsTooltip = ({ active, payload, label }) => {
    if (!active || !payload || payload.length === 0)
      return null

    const dayData = payload[0].payload
    const users = dayData.users || []

    return (
      <Paper style={{ padding: 12, maxWidth: 260 }}>
        <Typography variant="subtitle2" style={{ fontWeight: 600 }}>{label}</Typography>
        <Typography variant="body2" style={{ marginBottom: 8 }}>{dayData.callcount} chamada(s) no total</Typography>
        {users.length === 0 ? (
          <Typography variant="caption" color="textSecondary">Sem dados de usuário</Typography>
        ) : (
          users.map((u, idx) => (
            <Typography key={idx} variant="caption" style={{ display: 'block' }}>
              {u.username || 'Desconhecido'}: {u.callcount}
            </Typography>
          ))
        )}
      </Paper>
    )
  }

  renderCharts() {
    const { byDayData, byLLMData, byOutcomeData } = this.state
    const outcomeChartData = [
      { name: 'Sucesso', value: byOutcomeData.successcount || 0 },
      { name: 'Falha', value: byOutcomeData.failurecount || 0 }
    ]

    return (
      <Grid container spacing={2} style={{ marginBottom: 24 }}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardHeader title="Chamadas por dia" />
            <Divider />
            <CardContent>
              <ResponsiveContainer width="95%" height={300}>
                <LineChart data={byDayData}>
                  <XAxis dataKey="day" />
                  <YAxis allowDecimals={false} />
                  <CartesianGrid strokeDasharray="3 3" />
                  <Tooltip content={this.renderDailyCallsTooltip} />
                  <Line type="monotone" dataKey="callcount" stroke="#3F51B4" strokeWidth={2} dot={{ r: 3 }} />
                </LineChart>
              </ResponsiveContainer>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardHeader title="Tokens consumidos por dia" />
            <Divider />
            <CardContent>
              <ResponsiveContainer width="95%" height={300}>
                <BarChart data={byDayData}>
                  <XAxis dataKey="day" />
                  <YAxis allowDecimals={false} />
                  <CartesianGrid strokeDasharray="3 3" />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="tokensinput" stackId="tokens" fill="#3F51B4" name="Input" />
                  <Bar dataKey="tokensoutput" stackId="tokens" fill="#8BC34A" name="Output" />
                </BarChart>
              </ResponsiveContainer>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardHeader title="Chamadas por LLM" />
            <Divider />
            <CardContent>
              <ResponsiveContainer width="95%" height={300}>
                <BarChart data={byLLMData}>
                  <XAxis dataKey="llmname" />
                  <YAxis allowDecimals={false} />
                  <CartesianGrid strokeDasharray="3 3" />
                  <Tooltip />
                  <Bar dataKey="callcount" name="Chamadas" fill="#3F51B4" />
                </BarChart>
              </ResponsiveContainer>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardHeader title="Sucesso vs Falha" />
            <Divider />
            <CardContent>
              <ResponsiveContainer width="95%" height={300}>
                <PieChart>
                  <Tooltip />
                  <Legend />
                  <Pie data={outcomeChartData} dataKey="value" nameKey="name" outerRadius={100} label>
                    <Cell fill="#4CAF50" />
                    <Cell fill="#F44336" />
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    )
  }

  renderMainTable() {
    const { usageList } = this.state

    return (
      <Paper elevation={2} style={{ borderRadius: 12, overflow: 'hidden', marginBottom: 20 }}>
        <Box style={{ padding: '16px 20px', backgroundColor: '#3F51B4', color: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="subtitle1" style={{ fontWeight: 600, color: 'inherit' }}>
            Chamadas de IA
          </Typography>
          <Typography variant="caption" style={{ opacity: 0.8, color: 'inherit' }}>
            {this.state.count} registro(s)
          </Typography>
        </Box>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow style={{ backgroundColor: '#3F51B4' }}>
                <TableCell style={{ fontWeight: 700, color: '#fff' }} align="right">ID</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Data</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Usuário</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Origem</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }} align="right">ID Chamado/Chat</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>LLM</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }} align="right">Tokens In</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }} align="right">Tokens Out</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }} align="right">Latência (ms)</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>Sucesso</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {usageList.map((item, idx) => (
                <TableRow
                  key={item.id}
                  hover
                  onClick={() => this.openDetail(item)}
                  style={{ cursor: 'pointer', backgroundColor: idx % 2 === 0 ? '#fff' : '#f8fafc' }}>
                  <TableCell align="right" style={{ fontFamily: 'monospace', color: '#64748b' }}>{item.id}</TableCell>
                  <TableCell style={{ whiteSpace: 'nowrap' }}>
                    {item.createdat ? moment(item.createdat).format('DD/MM/YYYY HH:mm:ss') : '-'}
                  </TableCell>
                  <TableCell>{item.username || '-'}</TableCell>
                  <TableCell>
                    <Chip size="small" label={item.origin === 'accompaniment' ? 'Chamado' : 'Chat'} style={{ backgroundColor: '#e0e7ff', color: '#3730a3', fontWeight: 600 }} />
                  </TableCell>
                  <TableCell align="right" style={{ fontFamily: 'monospace' }}>{item.relationedid ? `#${item.relationedid}` : '-'}</TableCell>
                  <TableCell>{item.llmname || '-'}</TableCell>
                  <TableCell align="right">{item.tokensinput}</TableCell>
                  <TableCell align="right">{item.tokensoutput}</TableCell>
                  <TableCell align="right">{item.latencyms}</TableCell>
                  <TableCell>
                    {item.success
                      ? <Chip size="small" label="Sucesso" style={{ backgroundColor: '#dcfce7', color: '#166534', fontWeight: 600 }} />
                      : <Chip size="small" label="Falha" style={{ backgroundColor: '#fee2e2', color: '#991b1b', fontWeight: 600 }} />
                    }
                  </TableCell>
                </TableRow>
              ))}
              {usageList.length === 0 && (
                <TableRow>
                  <TableCell colSpan={10} align="center" style={{ padding: 40, color: '#94a3b8' }}>
                    Nenhuma chamada de IA encontrada no periodo informado.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    )
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props

    if (!this.isAdmGlobal) {
      const l = this.props.match.params.lang
      document.location.href = `/${l}/unavailable`
    }

    if (Api == null) {
      const l = this.props.match.params.lang
      document.location.href = `/${l}/unavailable`
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />

            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>
                <Card>
                  <CardContent className="background-title-search">
                    <Typography variant="h5">
                      Relatório de Uso de IA
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <form name='llmUsageReportForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>Filtros</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container style={{ marginBottom: 20 }} spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleDatePicker
                        label="Data Inicial"
                        name='dateStart'
                        stateName='dateStart'
                        changeDate={this.changeValues}
                        currentDate={this.state.dateStart}
                        fullWidth={true}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleDatePicker
                        label="Data Final"
                        name='dateEnd'
                        stateName='dateEnd'
                        changeDate={this.changeValues}
                        currentDate={this.state.dateEnd}
                        fullWidth={true}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoCompleteSearch
                        label="Usuário"
                        options={[]}
                        stateName='userFilter'
                        changeSelect={this.changeValues}
                        urlapi={Api.apiurlbase() + 'api/users/search/user'}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoComplete
                        label="LLM"
                        options={this.state.llmList}
                        stateName='llmFilter'
                        changeSelect={this.changeValues}
                        selected={this.state.llmList.find(item => item.id === this.state.llmFilter) || { id: 0, name: '' }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoComplete
                        label="Origem"
                        options={ORIGIN_OPTIONS}
                        stateName='originFilter'
                        changeSelect={this.changeValues}
                        selected={ORIGIN_OPTIONS.find(item => item.id === this.state.originFilter) || ORIGIN_OPTIONS[0]}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoComplete
                        label="Sucesso"
                        options={SUCCESS_OPTIONS}
                        stateName='successFilter'
                        changeSelect={this.changeValues}
                        selected={SUCCESS_OPTIONS.find(item => item.id === this.state.successFilter) || SUCCESS_OPTIONS[0]}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <TextField
                        label="ID relacionado (chamado ou chat)"
                        name='relationedIdFilter'
                        type="number"
                        value={this.state.relationedIdFilter}
                        onChange={(e) => this.setState({ relationedIdFilter: e.target.value })}
                        inputProps={{ min: 1, step: 1 }}
                        InputLabelProps={{ shrink: true }}
                        placeholder="Ex.: 4593"
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Grid container style={{ marginBottom: 10 }}>
                <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                  <Button type='submit' fullWidth variant='contained' color='secondary'>
                    Filtrar
                  </Button>
                </Grid>
                <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                  <Button fullWidth variant='contained' color='secondary' onClick={this.clearFilters}>
                    Limpar filtros
                  </Button>
                </Grid>
                {this.state.showGrid && (
                  <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                    <Button fullWidth variant='contained' color='secondary' onClick={this.exportExcel}>
                      Exportar Excel
                    </Button>
                  </Grid>
                )}
{this.state.showGrid && this.state.scheduleRequest && <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
  <ScheduleReportButton reportKey="llm-usage" request={this.state.scheduleRequest} color="secondary" />
</Grid>}
              </Grid>
            </form>

            {this.state.showGrid && (
              <>
                <Box style={{ marginTop: 32 }}>
                  {this.renderSummaryCards()}
                  {this.renderCharts()}
                  {this.renderMainTable()}
                </Box>

                <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                  <Grid item xs={12} md={3}>
                    <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                  </Grid>
                  <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                    {this.state.pageStart} a {this.state.pageEnd} de {this.state.count} registro(s)
                  </Grid>
                </Grid>
              </>
            )}

            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <LlmUsageDetailDrawer
              open={!!this.state.detailRow}
              row={this.state.detailRow}
              detail={this.state.detailData}
              loading={this.state.detailLoading}
              onClose={this.closeDetail}
            />

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification} />
          </Container>
        </main>
        <Footer />
      </div>
    )
  }
}

LLMUsageReport.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(calledsActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(LLMUsageReport)))
